/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsPortfolioListRequest {
    getFixupPrototypeFunction() { return AppSecopsPortfolioListRequest.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsPortfolioListRequest>): AppSecopsPortfolioListRequest {
        let obj = Object.assign(new AppSecopsPortfolioListRequest(), model);
        AppSecopsPortfolioListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsPortfolioListRequest>): AppSecopsPortfolioListRequest {
        if (!model) return null;
        return AppSecopsPortfolioListRequest.newInstance(<AppSecopsPortfolioListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsPortfolioListRequest) {
        if (!obj) return;

        models.AppSecopsPortfolioListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsPortfolioListRequest): boolean {
        Object.setPrototypeOf(obj, AppSecopsPortfolioListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.AppSecopsPortfolioFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.AppSecopsPortfolioSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.AppSecopsPortfolioSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.AppSecopsPortfolioFilter;

}
